<template>
    <div id="othen">

    </div>
</template>

<script>
    export default {
        name: "Othen"
    }
</script>

<style scoped>

</style>
